import { Component, Input } from '@angular/core';
import { UiModule } from '@shared/ui/ui.module';
import { RetailMediaCampaignType } from '@rmn/models/enums/retail-media-campaign-type.enum';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'rm-retail-media-parameters-info',
    standalone: true,
    imports: [
        CommonModule,
        UiModule
    ],
    templateUrl: './retail-media-parameters-info.component.html',
    styleUrls: ['./retail-media-parameters-info.component.scss']
})
export class RetailMediaParametersInfoComponent {
    @Input() public campaignType!: RetailMediaCampaignType | null;

    protected get isSelfAdvertising(): boolean {
        return this.campaignType === RetailMediaCampaignType.RETAIL_MEDIA_SELF_ADVERTISING;
    }
}
